import { getLocale } from "../runtime";

const sv_iconforward = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Framåt`
};

const iconforward = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconforward(inputs)
	return "iconForward";
};

export { iconforward as "iconForward" };